<template>
  <div v-if="isLoading">
    <div :class="$style.actionTermsWrapper">
      <h2 :class="$style.actionTitleImage">{{ dataAction.termsOfPromotionTitle }}</h2>
      <Markdown :class="$style.actionTermsText" :text="displayedTextTerms" />
      <BitButton
        v-if="shouldShowButtonTerms"
        :class="[
          $style.actionShowMoreTermsBotton,
          { [$style.actionShowMoreRotate]: showAll.termsOfPromotion },
        ]"
        type="secondary"
        @click="() => toggleShowAll('termsOfPromotion')"
      >
        <template #prependIcon>
          <img src="/images/common/ico_dropdown_arrow_down.svg?url_encode" alt="" />
        </template>
        {{ showAll.termsOfPromotion ? showLess : showMore }}
      </BitButton>
    </div>
    <template v-if="!activeFinaledRoundTournament && !activeFinaledRoundTournamentComingSoon">
      <h2 :class="$style.actionTitleImage">
        {{ dataAction.rewardsTitle }}
      </h2>
      <div :class="$style.actionWinnersWrapper">
        <PrizePlaceCard
          v-for="reward in dataAction.rewards"
          :key="reward.title"
          :title="reward.title"
          :image-card="reward.icon.url"
          :prize="reward.prize"
        />
      </div>
    </template>
    <template v-if="activeFinaledRoundTournament">
      <h2 :class="$style.actionTitleImage">{{ dataAction.rewardsTitle }}</h2>
      <div :class="$style.actionWinnersWrapper">
        <PrizePlaceCard
          v-for="(reward, index) in dataAction.rewards"
          :key="reward.title"
          :title="nicknames[index] || reward.title"
          :image-card="reward.icon.url"
          :prize="prizes[index] || reward.prize"
        />
      </div>

      <BitButton
        :class="[
          $style.actionShowMoreTermsBotton,
          { [$style.actionShowMoreRotate]: showAllRewards },
        ]"
        type="secondary"
        @click="toggleShowAllRewards"
      >
        <template #prependIcon>
          <img src="/images/common/ico_dropdown_arrow_down.svg?url_encode" alt="" />
        </template>
        {{ showAllRewards ? showLess : showMore }}
      </BitButton>
      <div :class="$style.raceTableAction">
        <RaceTable v-if="showAllRewards" :race-id="raceData" :init="true" />
      </div>
    </template>

    <template v-if="activeFinaledRoundTournamentComingSoon">
      <h2 :class="$style.actionTitleImage">{{ dataAction.rewardsTitle }}</h2>
      <div :class="$style.actionWinnersWrapper">
        <PrizePlaceCard
          v-for="reward in dataAction.rewards"
          :key="reward.title"
          :title="reward.title"
          :image-card="reward.icon.url"
          :prize="reward.prize"
        />
      </div>

      <BitButton
        :class="[
          $style.actionShowMoreTermsBotton,
          { [$style.actionShowMoreRotate]: showAllRewards },
        ]"
        type="secondary"
        @click="toggleShowAllRewards"
      >
        <template #prependIcon>
          <img src="/images/common/ico_dropdown_arrow_down.svg?url_encode" alt="" />
        </template>
        {{ showAllRewards ? showLess : showMore }}
      </BitButton>

      <div v-if="showAllRewards" :class="$style.raceTableAction">
        <div :class="$style.tableActionRewards">
          <div :class="$style.tableActionRewardsHeader">
            <span>{{ dataAction.tableWinner }}</span>
            <span>{{ dataAction.tablePrize }}</span>
            <span>{{ dataAction.tableSum }}</span>
          </div>
          <div
            v-for="(item, index) in activeFinaledRoundTournamentComingSoon.raceData.raceTableCustom"
            :key="index"
            :class="$style.tableActionRewardsCell"
          >
            <span>{{ item.winner }}</span>
            <span>{{ item.prize }}</span>
            <span :class="$style.tableActionRewardsPrize">{{ item.networkCustomSum }}</span>
          </div>
        </div>
      </div>
    </template>

    <h2 data-anchor="scrollTo" :class="$style.actionTitleImage">
      {{ dataAction.roundsTitle }}
    </h2>
    <div :class="$style.actionsRoundWrapper">
      <CardAction
        v-for="race in tournamentsListToShow"
        :key="race.raceData.ssId"
        :race-ss-id="race.raceData.ssId"
        :data="data"
        :is-tournaments-finished="race.tournamentData.status === ERaceStatus.finished"
      />
    </div>
    <template v-if="specialEventBonuses.length >= 1">
      <h2 :class="$style.actionTitleImage">{{ dataAction.titleActionBonuses }}</h2>
      <div :class="$style.promotionCardWrapper">
        <BonusPromotionCard
          v-for="bonus in specialEventBonuses"
          :key="bonus.bonusId"
          :bonus="bonus"
        />
      </div>
    </template>
    <h2 :class="$style.actionTermsTitme">{{ dataAction.termsAndContitionsTitle }}</h2>
    <Markdown :class="$style.actionTermsText" :text="displayedText" />
    <BitButton
      v-if="shouldShowButton"
      :class="[
        $style.actionShowMoreTermsBotton,
        { [$style.actionShowMoreRotate]: showAll.termsAndConditions },
      ]"
      type="secondary"
      @click="() => toggleShowAll('termsAndConditions')"
    >
      <template #prependIcon>
        <img src="/images/common/ico_dropdown_arrow_down.svg?url_encode" alt="" />
      </template>
      {{ showAll.termsAndConditions ? showLess : showMore }}
    </BitButton>
  </div>
  <ActionsBlockSkeleton v-else />
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import CardAction from '~/components/action/cardAction.vue';
import PrizePlaceCard from '~/components/action/prizePlaceCard.vue';
import BonusPromotionCard from '~/components/bonus/promotionCard.vue';
import ActionsBlockSkeleton from '~/components/infoPage/actionsBlockSkeleton.vue';
import Markdown from '~/components/markdown.vue';
import RaceTable from '~/components/race/table.vue';
import { useSnippet } from '~/composables/useSnippet';
import { useStoreSsTournaments } from '~/stores/softswiss/tournaments';
import { useStoreActions } from '~/stores/strapi/actions';
import { useStoreBonuses } from '~/stores/strapi/bonuses';
import { useStoreBonusesTabs } from '~/stores/strapi/bonusesTabs';
import { useStoreButtonTitles } from '~/stores/strapi/buttonTitles';
import { useStoreRaces } from '~/stores/strapi/races';
import { EBonusType } from '~/types/bonuses';
import { ERaceStatus, ERaceType } from '~/types/races';
import type {
  ComponentInfoPageBlocksRacesBlock,
  ComponentInfoPageBlocksActionsBlock,
} from '~/types/infoPages';
import type { IPlayerTournamentData } from '~/types/softswiss/ssTournaments';

type CombinedType = ComponentInfoPageBlocksRacesBlock | ComponentInfoPageBlocksActionsBlock;

const props = defineProps({
  data: {
    type: Object as unknown as PropType<CombinedType>,
    required: true,
  },
});

const dataAction = props.data as ComponentInfoPageBlocksActionsBlock;

const storeBonuses = useStoreBonuses();
const storeActions = useStoreActions();
const storeRaces = useStoreRaces();
const snippet = useSnippet();
const storeButtonsTitle = useStoreButtonTitles();
const storeSsTournaments = useStoreSsTournaments();
const storeBonusesTabs = useStoreBonusesTabs();
const isLoading = ref(true);

/** Show All rewards */
const showAllRewards = ref(false);
const toggleShowAllRewards = () => {
  showAllRewards.value = !showAllRewards.value;
};

/** Show All terms */
type ShowAllKeys = 'termsAndConditions' | 'termsOfPromotion';

const showAll = ref<Record<ShowAllKeys, boolean>>({
  termsAndConditions: false,
  termsOfPromotion: false,
});

const toggleShowAll = (key: ShowAllKeys) => {
  showAll.value[key] = !showAll.value[key];
};

const createTruncatedText = (text: string, linesCount: number) => {
  const lines = text.split('\n');
  return lines.slice(0, linesCount).join('\n') + '...';
};

const truncatedText = computed(() => createTruncatedText(dataAction.termsAndConditionsText, 3));
const truncatedTextTerms = computed(() => createTruncatedText(dataAction.termsOfPromotionText, 4));

const displayedText = computed(() =>
  showAll.value.termsAndConditions ? dataAction.termsAndConditionsText : truncatedText.value
);
const displayedTextTerms = computed(() =>
  showAll.value.termsOfPromotion ? dataAction.termsOfPromotionText : truncatedTextTerms.value
);

const shouldShowButton = computed(() => dataAction.termsAndConditionsText.split('\n').length > 3);
const shouldShowButtonTerms = computed(
  () => dataAction.termsOfPromotionText.split('\n').length > 4
);

const showMore = computed(() => storeButtonsTitle.showMoreGames);
const showLess = computed(() => storeButtonsTitle.showLessGames);

/** show all terms */

const statusOrder: { [key in ERaceStatus]: number } = {
  [ERaceStatus.active]: 1,
  [ERaceStatus.scheduled]: 2,
  [ERaceStatus.finished]: 3,
  [ERaceStatus.joined]: 0,
};

const tournamentsListToShow = computed(() => {
  return storeSsTournaments.tournamentsExtended
    .filter((tournament) => tournament.raceData.raceType === ERaceType.SpecialEvent)
    .sort((a, b) => {
      return statusOrder[a.tournamentData.status] - statusOrder[b.tournamentData.status];
    });
});

const activeFinaledRoundTournament = computed(() => {
  return tournamentsListToShow.value.find(
    (tournament) =>
      tournament.raceData.actionFinaledRound &&
      tournament.tournamentData.status === ERaceStatus.active
  );
});

const activeFinaledRoundTournamentComingSoon = computed(() => {
  return tournamentsListToShow.value.find(
    (tournament) =>
      tournament.raceData.actionFinaledRound &&
      tournament.tournamentData.status === ERaceStatus.scheduled
  );
});

const tournamentExtended = computed(() => {
  return tournamentsListToShow.value.find((t) =>
    t.tournamentData.frontend_identifier?.toLowerCase()
  );
});

const raceData = computed(() => {
  return tournamentExtended.value?.tournamentData.frontend_identifier;
});

interface LeaderboardTableInterface extends IPlayerTournamentData {
  prizes: string[];
  isCurrentUser?: boolean;
}

const leaderboardTableAll = computed((): LeaderboardTableInterface[] => {
  if (!tournamentExtended.value) {
    return [];
  }

  const tournament = tournamentExtended.value.tournamentData;
  const customPrizeArray = tournamentExtended.value?.raceData.raceTableCustom;
  const leaderboard = tournament?.top_players?.map((player, index) => {
    const playerPrize = tournament.prizes?.find(
      (prize) => prize.award_place === player.award_place
    );
    const prizes: string[] = [];

    if (playerPrize?.money_award_cents && playerPrize.money_award) {
      const newMoney =
        customPrizeArray[index] !== undefined
          ? customPrizeArray[index].prize
          : customPrizeArray[customPrizeArray.length - 1].prize;
      prizes.push(`${snippet.format(newMoney !== undefined ? newMoney : `0_auto_currency`)}`);
    }

    if (playerPrize?.freespins_count) {
      prizes.push(`${playerPrize?.freespins_count} FS`);
    }

    if (playerPrize?.chargeable_comp_points) {
      prizes.push(`${playerPrize?.chargeable_comp_points} CP`);
    }

    return {
      ...player,
      nickname: `${player.nickname.substring(0, 4)}****`,
      prizes,
    } as LeaderboardTableInterface;
  });

  if (leaderboard) {
    return leaderboard;
  }

  return [];
});

const sortedLeaderboard = computed(() => {
  return leaderboardTableAll.value.slice().sort((a, b) => a.award_place - b.award_place);
});
const nicknames = computed(() => {
  return sortedLeaderboard.value.map((entry) => entry.nickname);
});
const prizes = computed(() => {
  return sortedLeaderboard.value.map((entry) => entry.prizes[0]);
});

const specialEventBonuses = computed(() => {
  return storeBonuses.allBonusesWithStatuses.filter(
    (bonus) => bonus.bonusType === EBonusType.SpecialEvent
  );
});

const loadTournamentHistory = async () => {
  const tournamentIds = storeSsTournaments.tournamentsExtended.map((t) => t.tournamentData.id);
  const raceIds = storeRaces.activeRaces
    .filter((p) => p.historicalTournamentsId)
    .map((t) => Number(t.historicalTournamentsId));

  await Promise.all(
    raceIds
      .map((id: any) => {
        if (!tournamentIds.includes(id)) {
          return storeSsTournaments.loadTournamentById(id);
        }
        return null;
      })
      .filter((el) => el !== null)
  );
};

onMounted(async () => {
  isLoading.value = false;
  storeBonusesTabs.loadBonusesTabs();
  await Promise.all([
    storeSsTournaments.loadTournaments(),
    storeRaces.loadRacesData(),
    storeActions.loadActionsData(),
    storeBonuses.loadBonusesData(),
  ]);
  await storeSsTournaments.loadPlayerStatusesInTournaments();

  await loadTournamentHistory();

  isLoading.value = true;
});
</script>

<style lang="scss" module src="./actionsBlock.scss"></style>
